import * as NotificationsActionTypes from '../../actions/notifications/types';

export function notificationsReducer(state = {}, action) {
    switch (action.type) {
        case NotificationsActionTypes.ADD: {
            const notification = action.payload;

            return {
                ...state,
                [notification.id]: notification,
            };
        }

        case NotificationsActionTypes.REMOVE: {
            const notification = action.payload;

            const nextState = { ...state };
            delete nextState[notification.id];

            return nextState;
        }

        default:
            return state;
    }
}
